<template>
    <div dir="rtl">
        <input type="text" class="form-control mb-2"
               v-model="addressLocal"
               @blur="emitAddress"
               placeholder="العنوان (اكتب اسم المنطقة أو الشارع)">
        <div ref="mapEl" style="height: 280px; border:1px solid #dee2e6; border-radius:6px; direction:ltr;"></div>
        <small class="text-muted d-block mt-1">
            انقر الخريطة لتحديد الموقع — Lat: {{ fmt(value && value.lat) }}, Lng: {{ fmt(value && value.lng) }}
        </small>
    </div>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Marker-icon fix for Vite (uses import.meta.url to resolve PNGs from leaflet/dist/images).
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: new URL('leaflet/dist/images/marker-icon-2x.png', import.meta.url).href,
    iconUrl:       new URL('leaflet/dist/images/marker-icon.png',    import.meta.url).href,
    shadowUrl:     new URL('leaflet/dist/images/marker-shadow.png',  import.meta.url).href,
});

export default {
    name: 'MapPicker',
    props: {
        value: { type: Object, default: () => ({ lat: null, lng: null }) },
        address: { type: String, default: '' }
    },
    data() { return { map: null, marker: null, addressLocal: this.address }; },
    mounted() {
        const lat = Number(this.value && this.value.lat) || 32.8872; // Tripoli default
        const lng = Number(this.value && this.value.lng) || 13.1913;
        this.map = L.map(this.$refs.mapEl).setView([lat, lng], 13);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            { attribution: '© OpenStreetMap', maxZoom: 19 }).addTo(this.map);
        if (this.value && this.value.lat) {
            this.marker = L.marker([lat, lng]).addTo(this.map);
        }
        this.map.on('click', (e) => {
            const ll = e.latlng;
            if (this.marker) this.marker.setLatLng([ll.lat, ll.lng]);
            else this.marker = L.marker([ll.lat, ll.lng]).addTo(this.map);
            this.$emit('input', { lat: ll.lat, lng: ll.lng });
        });

        // The map is almost always created while still inside a hidden modal,
        // so Leaflet measures a wrong/zero size and only paints a corner patch.
        // Recompute the size whenever the container actually resizes (i.e. when
        // the modal becomes visible).
        if (window.ResizeObserver) {
            this._ro = new ResizeObserver(() => {
                if (this.map) this.map.invalidateSize();
            });
            this._ro.observe(this.$refs.mapEl);
        }
        setTimeout(() => { if (this.map) this.map.invalidateSize(); }, 450);
    },
    beforeDestroy() {
        if (this._ro) { this._ro.disconnect(); this._ro = null; }
        if (this.map) { this.map.remove(); this.map = null; }
    },
    watch: {
        address(v) { this.addressLocal = v; },
        // React to programmatic value changes — e.g. an Edit dialog that prefills
        // coordinates AFTER this component mounted. mounted() reads `value` once and
        // there is no other refresh, so without this watcher an existing school's
        // pin/center never appears when editing.
        value(v) {
            if (!this.map || !v || v.lat == null || v.lng == null) return;
            const ll = [Number(v.lat), Number(v.lng)];
            if (this.marker) this.marker.setLatLng(ll);
            else this.marker = L.marker(ll).addTo(this.map);
            this.map.setView(ll, 13);
        },
    },
    methods: {
        emitAddress() { this.$emit('update:address', this.addressLocal); },
        fmt(n) { return (n === null || n === undefined || n === '') ? '—' : Number(n).toFixed(5); }
    }
};
</script>
